(function ($) {
    // SELECTORS
    const loadingSelector = ".section_subscribe__loading";
    const formSelector = ".section_subscribe__form";
    const thankYouMessageSelector = ".section_subscribe__thank_you";

    /**
     * INIT
     */

    const email = getEmail();
    const firstname = getFirstName();
    setupHubspotFormEvents(email, firstname);

    if (!email) {
        setTimeout(() => showSection(formSelector), 1000);
        return;
    }

    /**
     * Functions
     */

    function getEmail() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        return params['email'];
    }

    function getFirstName() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        return params['firstname'];
    }

    function setupHubspotFormEvents(email, firstname) {
        firstname = firstname || email;

        window.addEventListener('message', event => {
            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                if (email) {
                    showSection(thankYouMessageSelector, true);
                }
            }

            if (email && event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
                $('.section_subscribe__form .hbspt-form form input[type=email]').val(email);
                $('.section_subscribe__form .hbspt-form form .hs_firstname input[type=text]').val(firstname);
                setTimeout(() => $('.section_subscribe__form .hbspt-form form').submit(), 200);
            }
        });
    }

    function showSection(selector, scrollTo = false) {
        $(formSelector).hide();
        $(thankYouMessageSelector).hide();
        $(loadingSelector).hide();

        $(selector).show();

        if (scrollTo) {
            scrollToForm(selector);
        }
    }

    function scrollToForm(el) {
        const $el = $(el);

        $('html,body').stop();
        $([document.documentElement, document.body]).animate({
            scrollTop: $el.offset().top - 200
        });
    }

})(window.jQuery);